export const setCategoriasLp = (state, payload) => {
    state.categoriasLp = payload;
}

export const setUnidadesProcedenciaLP = (state, payload) => {
    state.unidadesProcedenciaLP = payload;
}

export const setDadosPacienteLp = (state, payload) => {
    state.dadosPacienteLp = payload;
}


